import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { useHost } from '@xing-com/crate-xinglet';
/* oxlint-disable no-restricted-imports */
import type { TopBarProps } from '@xing-com/top-bar';
export { ActionSlot } from '@xing-com/top-bar';
/* oxlint-enable no-restricted-imports */

type CrateTopBarProps = {
  hideLoggedOut?: boolean;
  subHeaderContent?: React.ReactNode;
  isSticky?: boolean;
  isLoggedOut?: boolean;
} & TopBarProps;

export const TopBar: React.FC<CrateTopBarProps> = ({
  hideLoggedOut,
  ...props
}) => {
  const { isLoggedOut } = useLoginState();
  const { XingletLoader } = useHost();

  return isLoggedOut && hideLoggedOut ? null : (
    <XingletLoader name="@xing-com/crate-xing-entrypoint" topBar={props} />
  );
};
